import React, { useState, useEffect, useRef } from "react";
import { Modal } from "@mui/material";
import { useAuth } from "../../features/auth/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import api from "../../api/api";
import DataTableListing from "../DataTableListing/DataTableListing";
import search_bar from "../../assets/images/search.svg";
import sort from "../../assets/images/sort.png";
import "./AccessRoleModal.css";
import advisor_modal from "../../assets/images/advisor_modal.svg";
import specialist_modal from "../../assets/images/specialist_modal.svg";
import students_modal from "../../assets/images/students_modal.svg";
import hod_modal from "../../assets/images/hod_modal.svg";
import {getTeacherAndEnrolled, resetTeacherAndEnrolledList} from "../../state/actions/getTeacherAndEnrolledListAction";
import { getAccessControlRole } from "../../state/actions/getAccessControlRoleAction";
import { toast } from "react-toastify";
import AddProfilePopup from "../Add Profile/AddProfilePopup";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import EnrollmentResponsiveCards from "../../modules/admin/Dashboard/RecentEnrollment/EnrollmentResponsiveCards";
import SearchComponent from "../SearchComponent/SearchComponent";
// ── Config per mode , having two modals
const CONFIG = {
  advisor: {
    title: "Add Advisor",
    searchPlaceholder: "Search Teachers",
    img:advisor_modal,
    confirmLabel: "Create Advisor",
    multiSelect: false,
    role: "advisor",
  },
   specialist: {
    title: "Add Specialist",
    searchPlaceholder: "Search Teachers",
    img:specialist_modal,
    confirmLabel: "Create Learning Specialist",
    multiSelect: false,
    role: "learning specialist",
  },
  student: {
    title: "Assign Students",
    searchPlaceholder: "Search Students",
    img:students_modal,
    confirmLabel: "Assign Students",
    multiSelect: true,
    role: null,
  },
   hod: {
    title: "Add HOD",
    searchPlaceholder: "Search Teachers",
    img:hod_modal,
    confirmLabel: "Assign HOD",
    multiSelect: false,
    role: "advisor",
  },
};

// ── Component ----
function AccessRoleModal({ open, onClose, mode = "advisor",role, teacher_id, subject_id, existingHod  }) {
  const config = CONFIG[mode];
  const { token } = useAuth();
  const dispatch  = useDispatch();

  const [selectedStudentsMap, setSelectedStudentsMap] = useState({});
  const [searchText, setSearchText]   = useState("");
  const [selectedKey, setSelectedKey]   = useState(null);  // single select
  const [selectedKeys, setSelectedKeys] = useState([]);    // multi select
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [allStudents, setAllStudents]   = useState([]);
  const [studentsLoading, setStudentsLoading] = useState(false);
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [sortValue, setSortValue] = useState( mode === "student" ? "newest" : "Newest");
  const sortRef = useRef(null);
  const [showAddTeacher, setShowAddTeacher] = useState(false);
  const [hodConfirmModal, setHodConfirmModal] = useState({ open: false });
  // const [currentPage, setCurrentPage] = useState(1);
  const [studentTotal, setStudentTotal] = useState(0);
  const [advisorConfirmModal, setAdvisorConfirmModal] = useState({ open: false });
  

const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

 const teacherSortOptions = [
  { label: "Name : A - Z", value: "Name:A-Z" },
  { label: "Name : Z - A", value: "Name:Z-A" },
  { label: "Newest First", value: "Newest" },
  { label: "Oldest First", value: "Oldest-First" },
];

  const studentSortOptions = [
  { label: "Name : A - Z", value: "a-z" },
  { label: "Name : Z - A", value: "z-a" },
  { label: "Newest First", value: "newest" },
  { label: "Oldest First", value: role === "ls" ? "Oldest-First" : "oldest-first" },
  { label: "Grade High to Low", value: "htl" },
  { label: "Grade Low to High", value: "lth" },
];

const sortOptions = mode === "student" ? studentSortOptions : teacherSortOptions;

// ── Add these states ──
const [showGradeMenu, setShowGradeMenu] = useState(false);
const [gradeValue, setGradeValue] = useState("");
const gradeRef = useRef(null);

const gradeOptions = [
  { label: "Pre-Kindergarten", value: "1" },
  { label: "Kindergarten", value: "2" },
  { label: "Grade 1", value: "3" },
  { label: "Grade 2", value: "4" },
  { label: "Grade 3", value: "5" },
  { label: "Grade 4", value: "6" },
  { label: "Grade 5", value: "7" },
  { label: "Grade 6", value: "8" },
  { label: "Grade 7", value: "9" },
  { label: "Grade 8", value: "10" },
  { label: "Grade 9", value: "11" },
  { label: "Grade 10", value: "12" },
  { label: "Grade 11", value: "13" },
  { label: "Grade 12", value: "14" },
];


useEffect(() => {
  const timer = setTimeout(() => setDebouncedSearch(searchText), 400);
  return () => clearTimeout(timer);
}, [searchText]);

// useEffect(() => {
//   setCurrentPage(1);
// }, [sortValue, gradeValue, mode, debouncedSearch]); 

// ── Combine both in existing useEffect ──
useEffect(() => {
  const handleClickOutside = (e) => {
    if (sortRef.current && !sortRef.current.contains(e.target)) {
      setShowSortMenu(false);
    }
    if (gradeRef.current && !gradeRef.current.contains(e.target)) {
      setShowGradeMenu(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);
  // ── Redux state for teacher list ─────────────────────
  const { teacherList, isLoading, count  } = useSelector(
    (state) => state.getTeacherAndEnrolled
  );

//   useEffect(() => {
//   if (open) {
//     setSortValue(mode === "student" ? "newest" : "Newest");
//   }
// }, [open, mode]);

  // ── Fetch teacher list when modal opens ──────────────
  useEffect(() => {
    if (!open) {
      setSearchText("");
      setDebouncedSearch("");
      setSelectedKey(null);
      setSelectedStudentsMap({});
      setSelectedKeys([]);
      setAllStudents([]);
      setGradeValue(""); 
      setShowAddTeacher(false);
      return;
    }
    const effectiveSort =
    sortValue || (mode === "student" ? "newest" : "Newest");

    if (mode === "student") {
      // ── Fetch all_students into LOCAL state only ──
      setStudentsLoading(true);
      const params = new URLSearchParams({ role: role ?? "advisor", type: "all_students" });
      if (effectiveSort) params.append("sort", effectiveSort);
      if (gradeValue) params.append("grade", gradeValue); 
      if (debouncedSearch)  params.append("search", debouncedSearch);
      if (school_id) params.append("school_id", school_id); 
      // params.append("page", String(currentPage));
      api.get(
        `adminpage/access-control/role/?${params.toString()}`,
        { headers: { "Content-Type": "application/json", Authorization: `Token ${token}` } }
      )
      .then((res) => {
        if (res.data?.status === 200) setAllStudents(res.data.data ?? []);
        setStudentTotal(res.data.count ?? 0);
      })
      .catch(console.error)
      .finally(() => setStudentsLoading(false));

    } else {
      dispatch(getTeacherAndEnrolled(token, "teacher_list",  undefined, effectiveSort || undefined, undefined, debouncedSearch || undefined, school_id,   mode === "hod" ? subject_id : undefined, mode === "hod" ? "hod" : undefined ));
    }
  }, [token, open, mode, sortValue, gradeValue, debouncedSearch]);

  const normalizedTeacherList = (teacherList ?? []).map((t) => ({
    ...t,
    key: t.teacher_id,
  }));

  const normalizedStudents = allStudents.map((s) => ({
    ...s,
    key: s.student_id,
  }));
  const data = mode === "student" ? normalizedStudents : normalizedTeacherList;
    const { school_id } = useSelector((state) => state.globalState);

const filtered = data;

  // ── Loading state per mode ───────────────────────────
  const tableLoading = mode === "student" ? studentsLoading : isLoading;

 const toggleStudent = (key, row) => {
  setSelectedKeys((prev) => {
    if (prev.includes(key)) {
      // Deselecting — remove from map too
      setSelectedStudentsMap((m) => {
        const updated = { ...m };
        delete updated[key];
        return updated;
      });
      return prev.filter((k) => k !== key);
    } else {
      // Selecting — store in map
      setSelectedStudentsMap((m) => ({ ...m, [key]: row }));
      return [...prev, key];
    }
  });
};

 const toggleAll = () => {
  const allKeys = filtered.map((s) => s.key);
  const allSelected = allKeys.every((k) => selectedKeys.includes(k));
  if (allSelected) {
    // Deselect all current page
    setSelectedKeys((prev) => prev.filter((k) => !allKeys.includes(k)));
    setSelectedStudentsMap((m) => {
      const updated = { ...m };
      allKeys.forEach((k) => delete updated[k]);
      return updated;
    });
  } else {
    // Select all current page
    setSelectedKeys((prev) => [...new Set([...prev, ...allKeys])]);
    setSelectedStudentsMap((m) => {
      const updated = { ...m };
      filtered.forEach((s) => { updated[s.key] = s; });
      return updated;
    });
  }
};
  const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  const day = date.toLocaleString("en-GB", { day: "2-digit" });
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
};

const executeAdvisorSubmit = async () => {
  setAdvisorConfirmModal({ open: false });
  const selectedTeachers = Object.values(selectedStudentsMap);

  setIsSubmitting(true);
  try {
    const result = await api.post(
      "adminpage/access-control/add-role/",
      {
        role:       config.role,
        teacher_id: selectedTeachers.map((t) => String(t.teacher_id)),
        email_id:   selectedTeachers.map((t) => t.teacher_email),
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    if (result.data?.status === 200) {
      const added   = result.data?.data?.added   ?? [];
      const skipped = result.data?.data?.skipped ?? [];
      const roleLabel = mode === "specialist" ? "Learning Specialist" : "Advisor";
      const roleParam = mode === "specialist" ? "ls" : "advisor";

      if (added.length > 0 && skipped.length === 0) {
        const names = added.map((t) => t.teacher_name).join(", ");
        toast.success(
          `${names} ${added.length > 1 ? "have" : "has"} been assigned as ${roleLabel} successfully.`,
          { position: "top-right" }
        );
        dispatch(getAccessControlRole(token, roleParam, "list"));
        onClose();
      } else if (added.length === 0 && skipped.length > 0) {
        const skippedNames = skipped.map((s) => `${s.teacher_name} (${s.reason})`).join(", ");
        toast.error(`${skippedNames}`, { position: "top-right" });
      } else if (added.length > 0 && skipped.length > 0) {
        const addedNames   = added.map((t) => t.teacher_name).join(", ");
        const skippedNames = skipped.map((s) => `${s.teacher_name} (${s.reason})`).join(", ");
        toast.warning(
          `${addedNames} assigned as ${roleLabel}. ${skippedNames}.`,
          { position: "top-right" }
        );
        dispatch(getAccessControlRole(token, roleParam, "list"));
        onClose();
      }
    }
  } catch (error) {
    const apiMessage = error.response?.data?.message;
    const shortMessage = apiMessage?.split(". ")[0];
    const roleLabel = mode === "specialist" ? "Learning Specialist" : "Advisor";
    toast.error(shortMessage ?? `Failed to assign as ${roleLabel}`, {
      position: "top-right"
    });
  } finally {
    setIsSubmitting(false);
  }
};
const totalCount = mode === "student"
  ? (studentTotal ?? 0)
  : (count ?? 0);
  
  // ── Student columns (multi checkbox select) ──
  const allFilteredKeys = filtered.map((s) => s.key);
  const allChecked = allFilteredKeys.length > 0 && allFilteredKeys.every((k) => selectedKeys.includes(k));
  // ── Teacher columns (single radio select) ──
  const advisorColumns = [
    {
      key: "checkbox",
      title: (
        <Checkbox
          checked={allChecked}
          onChange={toggleAll}
        />
      ),
      render: (_, row) => (
        <Checkbox
          checked={selectedKeys.includes(row.key)}
          onChange={(e) => { e.stopPropagation(); toggleStudent(row.key, row); }} 
        />
      ),
      // title: "",
      // render: (_, row) => {
      //   const isSelected = selectedKey === row.teacher_id;
      //   return (
      //     <div
      //       onClick={(e) => { e.stopPropagation(); setSelectedKey(row.teacher_id); }}
      //       style={{
      //         width: 20, height: 20, borderRadius: "50%",
      //         border: `2px solid ${isSelected ? "#0068FF" : "#d1d5db"}`,
      //         display: "flex", alignItems: "center", justifyContent: "center",
      //         flexShrink: 0, cursor: "pointer", transition: "border-color 0.2s",
      //       }}
      //     >
      //       {isSelected && (<div style={{ width: 10, height: 10, borderRadius: "50%", background: "#0068FF" }} />)}
      //     </div>
      //   );
      // },
    },
    {
      key: "teacher_name",
      title: "Teacher Name",
      render: (value, row) => <NameCell value={value} avatar={row.ai_avatar} />,
    },
    // ...(mode==="hod" ?[
    // //   { key: "teacher_department_roles",    title: "Role", headerStyle:{textAlign:"center"},  render: (value) => {
    //     const styles = {
    //       "advisor": { background: "#E6FFE5", color: "#28991F" ,textTransform:"capitalize"},
    //       "teacher": { background: "#EBF3FF", color: "#0068FF", textTransform:"capitalize" },
    //       "learning specialist": { background: "#ECCCFF", color: "#9803F2",textTransform:"capitalize" },
    //       "hod": { background: "#FFECD6", color: "#FF8A00",textTransform:"uppercase" },
    //     };

    //     const style = styles[value] || {
    //       background: "#f1f5f9",
    //       color: "#64748b",
    //     };

    //     return (
    //     <div style={{ display: "flex", justifyContent: "center" }}>
    //       <span
    //         style={{
    //           background: style.background,
    //           color: style.color,
    //           textTransform: style
    //           .textTransform,
    //           padding: "4px 12px",
    //           borderRadius: 999,
    //           fontSize: 12.5,
    //           fontWeight: 500,
    //           whiteSpace: "nowrap",
    //           display: "inline-block",
    //         }}
    //       >
    //         {value}
    //       </span>
    //       </div>
    //     );
    //   }
    // },
    // ]: []), 
    { key: "teacher_id",    title: "Teacher Id",   headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value}
        </div>
      ), },
    { key: "teacher_email", title: "Email Id",     render: (v) => <span>{v}</span> },
    { key: "created_at",  title: "Joining Date",  headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {formatDate(value)}
        </div>
      ),},
  ];

  const hodColumns = [
  {
    key: "radio",
    title: "",  // ← no select-all for HOD
    render: (_, row) => {
      const isSelected = selectedKey === row.teacher_id;
      return (
        <div
          onClick={(e) => { e.stopPropagation(); setSelectedKey(row.teacher_id); }}
          style={{
            width: 20, height: 20, borderRadius: "50%",
            border: `2px solid ${isSelected ? "#0068FF" : "#d1d5db"}`,
            display: "flex", alignItems: "center", justifyContent: "center",
            flexShrink: 0, cursor: "pointer", transition: "border-color 0.2s",
          }}
        >
          {isSelected && (
            <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#0068FF" }} />
          )}
        </div>
      );
    },
  },
  {
    key: "teacher_name",
    title: "Teacher Name",
    render: (value, row) => <NameCell value={value} avatar={row.ai_avatar} />,
  },
  {
    key: "teacher_department_roles", title: "Role", headerStyle: { textAlign: "center" },
    render: (value) => {
      const styles = {
        "advisor": { background: "#E6FFE5", color: "#28991F", textTransform: "capitalize" },
        "teacher": { background: "#EBF3FF", color: "#0068FF", textTransform: "capitalize" },
        "learning specialist": { background: "#ECCCFF", color: "#9803F2", textTransform: "capitalize" },
        "hod": { background: "#FFECD6", color: "#FF8A00", textTransform: "uppercase" },
      };
      const style = styles[value] || { background: "#f1f5f9", color: "#64748b" };
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <span style={{
            background: style.background, color: style.color,
            textTransform: style.textTransform, padding: "4px 12px",
            borderRadius: 999, fontSize: 12.5, fontWeight: 500,
            whiteSpace: "nowrap", display: "inline-block",
          }}>
            {value}
          </span>
        </div>
      );
    }
  },
  { key: "teacher_id", title: "Teacher Id", headerStyle: { textAlign: "center" },
    render: (value) => <div style={{ textAlign: "center" }}>{value}</div>
  },
  { key: "teacher_email", title: "Email Id", render: (v) => <span>{v}</span> },
  { key: "created_at", title: "Joining Date", headerStyle: { textAlign: "center" },
    render: (value) => <div style={{ textAlign: "center" }}>{formatDate(value)}</div>
  },
];

  const studentColumns = [
    {
      key: "checkbox",
      title: (
        <Checkbox
          checked={allChecked}
          onChange={toggleAll}
        />
      ),
      render: (_, row) => (
        <Checkbox
          checked={selectedKeys.includes(row.key)}
          onChange={(e) => { e.stopPropagation(); toggleStudent(row.key, row); }} 
        />
      ),
    },
    {
      key: "student_name",
      title: "Student Name",
      render: (value, row) => <NameCell value={value} avatar={row.student_profile_pic} />,
    },
    { key: "grade_name",           title: "Grade",            headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value}
        </div>
      ), },
    { key: "email",         title: "Email Id",        render: (v) => <span>{v}</span> },
    { key: "students_join_date",     title: "Joining Date",     headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {formatDate(value)}
        </div>
      ),  },
    { key: "assigned_teacher_name",  title: role === "ls" ? "Assigned Specialist" : "Assigned Advisor",  headerStyle: { textAlign: "center" }, render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value ?? "NA"}
        </div>
      ),
    },
  ];

const columns = mode === "student" 
  ? studentColumns 
  : mode === "hod" 
    ? hodColumns 
    : advisorColumns;

const executeHodSubmit = async () => {
    setHodConfirmModal({ open: false });
    setIsSubmitting(true);
    try {
      if (existingHod) {
        // ── UPDATE (PUT) ──
        const payload = { subject_id };
        if (selectedKey) payload.teacher_id = selectedKey;

        const result = await api.put(
          "adminpage/access-control/hod/update/",
          payload,
          { headers: { "Content-Type": "application/json", Authorization: `Token ${token}` } }
        );

        if (result.data?.status === 200 || result.data?.status === 201) {
          toast.success(selectedKey ? "HOD has been updated successfully." : "HOD has been removed from this department.");
          onClose();
        } else {
          toast.error(result.data?.message ?? "Failed to update HOD.");
        }
      } else {
        // ── ADD (POST) ──
        const selectedTeacher = teacherList.find((t) => t.teacher_id === selectedKey);
        if (!selectedTeacher) { setIsSubmitting(false); return; }

        const result = await api.post(
          "adminpage/access-control/hod/add-hod/",
          {
            teacher_name: selectedTeacher.teacher_name,
            teacher_id:   selectedTeacher.teacher_id,
            email_id:     selectedTeacher.teacher_email,
            subject_id:   subject_id,
          },
          { headers: { "Content-Type": "application/json", Authorization: `Token ${token}` } }
        );

        if (result.data?.status === 200 || result.data?.status === 201) {
          toast.success("Teacher assigned as HOD.");
          onClose();
        } else {
          toast.error(result.data?.message ?? "Failed to assign HOD.");
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.message ?? "Something went wrong.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // ── Confirm — POST to add-role API ───────────────────
const handleConfirm = async () => {

  if (mode === "student") {
    if (!selectedKeys.length) {
      toast.warning("Please select at least one student.");
      return;
    }

    setIsSubmitting(true);
    try {
      const selectedStudents = Object.values(selectedStudentsMap);
      const roleLabel = role === "ls" ? "Learning Specialist" : "Advisor";
      const roleParam = role === "ls" ? "ls" : "advisor";

      const result = await api.post(
        "adminpage/access-control/add-assigned-students/",
        {
          student_id: selectedStudents.map((s) => String(s.student_id)),
          email:      selectedStudents.map((s) => s.email),
          teacher_id: teacher_id,
          role:       role ?? "advisor",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      if (result.data?.status === 200) {
        const added   = result.data?.data?.added   ?? [];
        const skipped = result.data?.data?.skipped ?? [];

        // ── Scenario 1: All added ──
        if (added.length > 0 && skipped.length === 0) {
          const names = added.map((s) => s.student_name).join(", ");
          toast.success(
            `${names} ${added.length > 1 ? "have" : "has"} been assigned as ${roleLabel}'s student successfully.`,
            { position: "top-right" }
          );
          dispatch(getTeacherAndEnrolled(token, "enrolled_students", teacher_id, undefined, role ?? "advisor"));
          onClose();

        // ── Scenario 2: All skipped ──
        } else if (added.length === 0 && skipped.length > 0) {
          const skippedNames = skipped.map((s) => `${s.student_name} (${s.reason})`).join(", ");
          toast.error(skippedNames, { position: "top-right" });
          // stay open

        // ── Scenario 3: Some added, some skipped ──
        } else if (added.length > 0 && skipped.length > 0) {
          const addedNames   = added.map((s) => s.student_name).join(", ");
          const skippedNames = skipped.map((s) => `${s.student_name} (${s.reason})`).join(", ");
          toast.warning(
            `${addedNames} assigned to ${roleLabel}. ${skippedNames}.`,
            { position: "top-right" }
          );
          dispatch(getTeacherAndEnrolled(token, "enrolled_students", teacher_id, undefined, role ?? "advisor"));
          onClose();
        }
      }
    } catch (error) {
      const apiMessage = error.response?.data?.message;
      const shortMessage = apiMessage?.split(". ")[0];
      const roleLabel = role === "ls" ? "Learning Specialist" : "Advisor";
      toast.error(shortMessage ?? `Failed to assign students to ${roleLabel}.`, {
        position: "top-right",
      });
    } finally {
      setIsSubmitting(false);
    }
    return;
  }

  // ── HOD mode — validate first, then show confirm modal ──
  if (mode === "hod") {
    // Validate: for new HOD assignment, a teacher must be selected
    if (!selectedKey) {
      toast.warning("Please select a teacher.");
      return;
    }
    // Open confirmation modal — actual API call happens in executeHodSubmit
    setHodConfirmModal({ open: true });
    return;
  }

  // ── Non-student, non-HOD mode (advisor / specialist) ──
  if (!selectedKeys.length) {
    toast.warning("Please select a teacher.");
    return;
  }

  if (!teacherList?.length) {
    console.error("teacherList is empty");
    return;
  }

const selectedTeachers = Object.values(selectedStudentsMap);
  if (!selectedTeachers.length) {
    console.error("No teacher selected. selectedKey:", selectedKey);
    return;
  }

  setAdvisorConfirmModal({ open: true });

  // setIsSubmitting(true);
  // try {
  //   const result = await api.post(
  //     "adminpage/access-control/add-role/",
  //     {
  //    role:       config.role,
  //     teacher_id:  selectedTeachers.map((t) => String(t.teacher_id)),
  //     email_id:   selectedTeachers.map((t) => t.teacher_email),
  //     },
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Token ${token}`,
  //       },
  //     }
  //   );

  // if (result.data?.status === 200) {
  //     const added   = result.data?.data?.added   ?? [];
  //     const skipped = result.data?.data?.skipped ?? [];
  //     const roleLabel = mode === "specialist" ? "Learning Specialist" : "Advisor";
  //     const roleParam = mode === "specialist" ? "ls" : "advisor";
    
  //     // ── Scenario 1: All added ──
  // if (added.length > 0 && skipped.length === 0) {
  //   const names = added.map((t) => t.teacher_name).join(", ");
  //   toast.success(
  //     `${names} ${added.length > 1 ? "have" : "has"} been assigned as ${roleLabel} successfully.`,
  //     { position: "top-right" }
  //   );
  //   dispatch(getAccessControlRole(token, roleParam, "list"));
  //   onClose();

  // // ── Scenario 2: All skipped ──
  // }  else if (added.length === 0 && skipped.length > 0) {
  // const skippedNames = skipped.map((s) => `${s.teacher_name} (${s.reason})`).join(", ");
  // toast.error(
  //   `${skippedNames}`,
  //   { position: "top-right" }
  // );
  // // stay open
  // // ── Scenario 3: Some added, some skipped ──
  // } else if (added.length > 0 && skipped.length > 0) {
  //   const addedNames   = added.map((t) => t.teacher_name).join(", ");
  //   const skippedNames = skipped.map((s) => `${s.teacher_name} (${s.reason})`).join(", ");
  //   toast.warning(
  //     `${addedNames} assigned as ${roleLabel}. ${skippedNames}.`,
  //     { position: "top-right" }
  //   );
  //   dispatch(getAccessControlRole(token, roleParam, "list"));
  //   onClose();
  // }
  //   }
  // } catch (error) {
  //   const apiMessage = error.response?.data?.message;
  //   const shortMessage = apiMessage?.split(". ")[0];
  //   const roleLabel = mode === "specialist" ? "Learning Specialist" : "Advisor";
  //   toast.error(shortMessage ?? `Failed to assign as ${roleLabel}`, {
  //     position: "top-right"
  //   });
  // } finally {
  //   setIsSubmitting(false);
  // }
};

// ── Derive confirm modal label based on HOD action ──
const hodConfirmName = (() => {
  if (mode !== "hod") return "";
  if (existingHod && selectedKey) {
    // Replacing: show the newly selected teacher name
    const t = (teacherList ?? []).find((t) => t.teacher_id === selectedKey);
    return t?.teacher_name ?? "";
  }
  if (existingHod && !selectedKey) return ""; // removing — no name needed
  // New assignment
  const t = (teacherList ?? []).find((t) => t.teacher_id === selectedKey);
  return t?.teacher_name ?? "";
})();

const hodConfirmRole = existingHod ? (selectedKey ? "update hod" : "remove hod") : "hod";


  return (
    <>
      {showAddTeacher && (
        <AddProfilePopup
          entity="Teacher"
          toggleshowAddProfile={() => {
            setShowAddTeacher(false);
            // re-fetch teacher list after adding
            dispatch(
              getTeacherAndEnrolled(
                token,
                "teacher_list",
                undefined,
                sortValue || undefined,
              ),
            );
          }}
        />
      )}
      <Modal
        open={open && !showAddTeacher}
        disableEscapeKeyDown
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          onClose();
        }}
      >
        <div className="add-modal">
          {/* Header */}
          <div className="add-modal-header">
            <div className="add-modal-header-left">
              <div className="add-modal-avatar-placeholder">
                <img src={config.img} alt="modal icon" />
              </div>
              <span className="add-modal-title">
                {mode === "hod"
                  ? existingHod
                    ? "Edit HOD"
                    : "Add HOD"
                  : config.title}
              </span>
            </div>
            <button className="add-modal-close" onClick={onClose}>
              ✕
            </button>
          </div>

          {/* Toolbar */}
          <div className="add-modal-toolbar">
            <SearchComponent
              search={search_bar}
              searchPlaceholder={config.searchPlaceholder}
              value={searchText}
              onchange={(e) => setSearchText(e.target.value)}
            />
            {/* <div className="add-modal-search">
            <img src={search_bar} alt="search" />
            <input
              placeholder={config.searchPlaceholder}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div> */}
            <div className="add-modal-toolbar-right ">
              {mode === "student" && (
                <div style={{ position: "relative" }} ref={gradeRef}>
                  <button
                    className="grade-dropdown"
                    onClick={() => setShowGradeMenu((prev) => !prev)}
                  >
                    <span>
                      {gradeValue
                        ? gradeOptions.find((o) => o.value === gradeValue)
                            ?.label ?? "Select Grade"
                        : "Select Grade"}
                    </span>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M2 4L6 8L10 4"
                        stroke="#64748b"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>

                  {showGradeMenu && (
                    <div className="sort-menu" style={{ minWidth: 170, right: 0 }}>
                      <div
                        className="sort-options"
                        onClick={() => {
                          setGradeValue("");
                          setShowGradeMenu(false);
                        }}
                        style={{
                          color: !gradeValue ? "#0068FF" : "#374151",
                          fontWeight: !gradeValue ? 600 : 400,
                        }}
                      >
                        All Grades
                      </div>
                      {gradeOptions.map((option) => (
                        <div
                          className="sort-options"
                          key={option.value}
                          onClick={() => {
                            setGradeValue(option.value);
                            setShowGradeMenu(false);
                          }}
                          style={{
                            color:
                              gradeValue === option.value
                                ? "#0068FF"
                                : "#374151",
                            fontWeight: gradeValue === option.value ? 600 : 400,
                            background:
                              gradeValue === option.value ? "#f0f7ff" : "#fff",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f9fafb")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background =
                              gradeValue === option.value ? "#f0f7ff" : "#fff")
                          }
                        >
                          {option.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
              <div style={{ position: "relative" }} ref={sortRef}>
                <button
                  className="sort-button "
                  onClick={() => setShowSortMenu((prev) => !prev)}
                >
                  <img src={sort} alt="sort" />
                  Sort
                </button>

                {showSortMenu && (
                  <div className="sort-menu" style={{ right: 0 }}>
                    {sortOptions.map((option) => (
                      <div
                        className="sort-options"
                        key={option.value}
                        onClick={() => {
                          setSortValue(option.value);
                          setShowSortMenu(false);
                        }}
                        style={{
                          color:
                            sortValue === option.value ? "#0068FF" : "#374151",
                          fontWeight: sortValue === option.value ? 600 : 400,
                          background:
                            sortValue === option.value ? "#f0f7ff" : "#fff",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f9fafb")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background =
                            sortValue === option.value ? "#f0f7ff" : "#fff")
                        }
                      >
                        {option.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {(mode === "advisor" || mode === "specialist") && (
                <button
                  className="add-modal-add-teacher-btn"
                  onClick={() => setShowAddTeacher(true)}
                >
                  + Add Teacher
                </button>
              )}
            </div>
          </div>

          {/* DataTableListing */}
          <div className="add-modal-table-wrapper">
            {isMobile ? (
              <EnrollmentResponsiveCards
                data={filtered.map((item) => ({
                  ...item,
                  id: item.teacher_id,
                  key: item.teacher_id,
                  profilePic: item.ai_avatar,
                  name: item.teacher_name || "Unknown",
                  email: item.teacher_email || "-",
                  joinDate: new Date(item.created_at)
                    .toLocaleDateString("en-US", {
                      month: "short",
                      day: "2-digit",
                      year: "numeric",
                    })
                    .replace(",", "-")
                    .replace(" ", "-"),
                }))}
                userType={"teacher"}
                modal={true}
                selectedIds={selectedKeys}
                onToggle={(item) => toggleStudent(item.key, item)}
              />
            ) : (
              <DataTableListing
                columns={columns}
                dataSource={filtered}
                rowKey="key"
                pagination={
                  // totalCount > 0
                  //   ? {
                  //       currentPage: currentPage,
                  //       total: totalCount,
                  //       onChange: (page) => setCurrentPage(page),
                  //     }
                  //   :
                  false
                }
                checkable={false}
                loading={tableLoading}
                emptyText="No results found"
                bordered={false}
                size="default"
                rowHoverColor="#F7F7F7"
                scrollWrapperStyle={{
                  maxHeight: "325px",
                  overflowY: "auto",
                }}
              />
            )}
          </div>

          {/* Selected count — student mode only */}
          {mode === "student" && selectedKeys.length > 0 && (
            <p className="add-modal-selected-count">
              {selectedKeys.length} Student{selectedKeys.length > 1 ? "s" : ""}{" "}
              Selected
            </p>
          )}

          {/* Footer */}
          <div className="add-modal-footer">
            <button className="add-modal-cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button
              className="add-modal-create-btn"
              onClick={handleConfirm}
              disabled={isSubmitting}
            >
              {isSubmitting
                ? "Saving..."
                : mode === "hod"
                ? existingHod
                  ? "Update HOD"
                  : "Assign HOD"
                : config.confirmLabel}
            </button>
          </div>
        </div>
      </Modal>

      {/* ── HOD assign / update confirm modal ── */}
      <ConfirmDeleteModal
        open={hodConfirmModal.open}
        onClose={() => setHodConfirmModal({ open: false })}
        onConfirm={executeHodSubmit}
        name={hodConfirmName}
        role={hodConfirmRole}
      />

      <ConfirmDeleteModal
        open={advisorConfirmModal.open}
        onClose={() => setAdvisorConfirmModal({ open: false })}
        onConfirm={executeAdvisorSubmit}
        name={Object.values(selectedStudentsMap)
          .map((t) => t.teacher_name)
          .join(", ")}
        role={mode === "specialist" ? "specialist" : "advisor"}
      />
    </>
  );
}

// ── Shared sub-components reusing avatar + name  ─────
function NameCell({ value, avatar }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      {avatar ? (
        <img src={avatar} alt={value} style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
      ) : (
        <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#e2e8f0", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: "#94a3b8", fontWeight: 600 }}>
          {value?.charAt(0)}
        </div>
      )}
      <span>{value}</span>
    </div>
  );
}

function Checkbox({ checked, onChange }) {
  return (
    <div
      onClick={onChange}
      style={{
        width: 18, height: 18, borderRadius: 4, flexShrink: 0,
        border: `2px solid ${checked ? "#0068FF" : "#d1d5db"}`,
        background: checked ? "#0068FF" : "#fff",
        display: "flex", alignItems: "center", justifyContent: "center",
        cursor: "pointer", transition: "all 0.15s",
      }}
    >
      {checked && (
        <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
          <path d="M1 4L3.5 6.5L9 1" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )}
      {!checked && (
        <div style={{ width: 8, height: 2, background: "#fff", borderRadius: 1 }} />
      )}
    </div>
  );
}

export default AccessRoleModal;